/* istanbul ignore file */ import { useCallback, useEffect } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import { useHydration } from './useHydration';
import { useDispatch, useSelector } from 'react-redux';
import { createSetInitLoadingAction } from 'actions/actions';
export function useLocationChange(options) {
    const isHydrated = useHydration();
    const location = useLocation();
    const isEmbedded = useSelector((state)=>state.config.isEmbedded);
    const dispatch = useDispatch();
    const { setCurrentView, map, routes } = options;
    const handleLocationChange = useCallback(()=>{
        var _matches__route, _matches_;
        const matches = matchRoutes(routes, location.pathname);
        const matchedView = map[(_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : (_matches__route = _matches_.route) === null || _matches__route === void 0 ? void 0 : _matches__route.path];
        setCurrentView(matchedView === null || matchedView === void 0 ? void 0 : matchedView.view);
    }, [
        setCurrentView,
        location,
        map,
        routes
    ]);
    useEffect(()=>{
        if (!isHydrated) {
            return;
        }
        if (isEmbedded) {
            // Embedded starts in a loading state, therefore client side hydration expects the same state to be met.
            // Loading is disabled once client has been hydrated.
            dispatch(createSetInitLoadingAction({
                initLoading: false
            }));
        }
        handleLocationChange();
    }, [
        location,
        handleLocationChange,
        isHydrated,
        isEmbedded,
        dispatch
    ]);
}
